<!-- <div class="loginbg c page-content fade-in-up">
  <div class="container-md1">
    <br>
    <div class="row">
      <div class="col-12 text-center">

        <img src="../../assets/img/svayamlogo.jpg" width="5%">
      </div>
    </div>
    <div class="row" style="margin: 1%; color: white" *ngIf="select_acct == false">
      <div class="col-{{num}}" *ngIf="otpFlag">
        <div>
          <h6>LOGIN WITH OTP</h6>
          <br />
          <div class="row">
            <div class="col-4">Enter Mobile:</div>
            <div class="col-6">
              <input type="number" name="mobile_number" placeholder="Enter Mobile Number" autocomplete="off"
                class="form-control" [(ngModel)]="otpuser['mobile_number']" />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-primary" (click)="sendOtp()">
                Send
              </button>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="openOTP" style="font-size: smaller">
            <div class="col-3">Enter OTP:</div>
            <div class="col-7">
              <input class="form-control" id="text" type="password" name="otp" autocomplete="off"
                placeholder="Enter OTP" [(ngModel)]="otpuser['otp_no']" />
            </div>
            <div class="col-2">
              <button type="button" (click)="sendOtp()" class="btn btn-warning">
                Resend
              </button>
            </div>
          </div>
          <br />
          <div class="row" style="font-size: smaller">

            <div class="col-12 text-center">
              <button type="button" class="btn btn-info btn-block" (click)="LoginWithOtp()">
                LOGIN
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="passflag" class="col-{{num}}">
        <h6>LOGIN WITH PASSWORD</h6>
        <br />
        <div class="row">
          <div class="col-1"></div>
          <div class="col-{{passnum}}" style="font-size: smaller" *ngIf="phoneFlag">
            LOGIN WITH MOBILE:
            <input type="checkbox" style="margin-right: 2%; margin-top: 4px" name="test"
              [checked]="isChecked === check_box_type.APPLY_FOR_JOB"
              (click)="selectCheckBox(check_box_type.APPLY_FOR_JOB)" *ngIf="phoneFlag && emailFlag" />
          </div>
          <div class="col-{{passnum}}" style="font-size: smaller" *ngIf="emailFlag">
            LOGIN WITH EMAIL:
            <input type="checkbox" style="margin-right: 2%; margin-top: 4px" name="test" *ngIf="phoneFlag && emailFlag"
              [checked]="isChecked === check_box_type.MODIFY_A_JOB"
              (click)="selectCheckBox(check_box_type.MODIFY_A_JOB)" />
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="form-group">
              <input *ngIf="isChecked == 0" class="form-control" type="number" placeholder="Enter Mobile Number"
                [(ngModel)]="userdetails['phone_no']" />
              <input *ngIf="isChecked != 0" class="form-control" type="email" placeholder="Enter Email"
                [(ngModel)]="userdetails['email']" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <input class="form-control" type="password" autocomplete="off" placeholder="Enter Password "
              [(ngModel)]="userdetails['password']" />
          </div>
        </div>
        <br />
        <div class="row">

          <div class="col-12 text-center">
            <button class="btn btn-info btn-block" type="submit" (click)="submit()">LOGIN</button>
            <button class="btn btn-info btn-block" type="submit" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="goaFlag" style="margin:1% ;">
      <div class="col-12 text-center">

        <h6 style="color:white ;">
          LOG IN USING YOUR GOOGLE ACCOUNT
        </h6>
        <h5>
          <div id="signin_button"></div>
        </h5>
      </div>
    </div>
  </div>
</div>-->

<div class="modal" id="updatePass">
  <div class="modal-dialog-full-width modal-dialog momodel modal-fluid" style="max-width: 50%;">
    <div class="modal-content">

      <div class="modal-header">

        <h5 class="modal-title" style="font: bold; color: rgb(8, 96, 96);font-size: large;"> <i class="bi bi-key"></i>
          Update Password </h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()"
          style="background-color: rgba(239, 25, 25, 0.871);color: white;width: min-content;padding: 2px;">&times;</button>
      </div>
      <div class="modal-body">
        <br>
        <div id="boxBLUE1">
          <br>
          <div class="row">
            <div class="col-2"></div>
            <div class="col-3 ">
              <h6 style="margin-left:2% ;color: rgb(65, 212, 190);">Enter New Password:</h6>
            </div>
            <div class="col-5">

              <span class="form-control">
                <input type="password" name="password" id="password" placeholder="Enter New Password"
                  [(ngModel)]="pass['ident_verify_secret']" />
                <i class="bi bi-eye-slash" id="togglePassword"></i>
              </span>
            </div>
            <div class="col-2"></div>

          </div>
          <br>
          <div class="row">
            <div class="col-2"></div>

            <div class="col-3 ">
              <h6 style="margin-left:2%; color: rgb(65, 212, 190);">Confirm New Password:</h6>
            </div>
            <div class="col-5">
              <span class="form-control">
                <input type="password" name="password" id="password" placeholder="confirm New Password"
                  [(ngModel)]="pass['c_ident_verify_secret']" />

              </span>

            </div>
            <div class="col-2"></div>

          </div>


          <br>
          <div class="modal-footer">
            <button (click)="updatePassword()" class="btn btn-success">Update</button>&nbsp;&nbsp;
            <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="close()">Close</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="loginback">
  
  <div class="Parent">
     
  
    <div class="child1">
      <!-- <i class="fa fa-arrow-left" aria-hidden="true" style="justify-content:flex-start"></i> -->
   
      <h1>Login</h1>
      <div class="login-section">
       
      
        <div class="login-options">
          <div class="login-toggle" *ngIf="passflag && otpFlag">
           
            <label class="option-label">
              <input type="radio" name="loginType" value="password" [(ngModel)]="loginType"> Login with Password
            </label>
            <label class="option-label">
              <input type="radio" name="loginType" value="otp" [(ngModel)]="loginType"> Login with OTP
            </label>
          </div>
      
          <div class="otp-login" *ngIf="loginType === 'otp'">
            <!-- OTP login form -->
            <div *ngIf="otpFlag" class="col-{{num}}">
              <div>
                <h6>LOGIN WITH OTP</h6>
                <br />
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-8">
                    <input type="number" name="mobile_number" placeholder="Enter Mobile Number" autocomplete="off"
                      class="form-control input-field" [(ngModel)]="otpuser['mobile_number']" />
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary otpsenbtn" (click)="sendOtp()">
                      Send
                    </button>
                  </div>
                </div>
                <br />
                <div class="row"  style="font-size: smaller">
                  <div class="col-2"></div>
                  <div class="col-8">
                    <input class="form-control input-field" id="text" type="password" name="otp" autocomplete="off"
                      placeholder="Enter OTP" [(ngModel)]="otpuser['otp_no']" />
                  </div>
                  <div class="col-2">
                    <button type="button" (click)="sendOtp()" class="btn btn-warning otpsenbtn">
                       Resend
                    </button>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-12 text-center">
                    <button class="btn btn-info btn-block loginbtn" type="submit" (click)="LoginWithOtp()"><i
                        class="fa fa-sign-in"></i> LOGIN</button>
      
                  </div>
                </div>
              </div>
            </div>
          </div>
      
          <div class="password-login" *ngIf="loginType === 'password'">
            <!-- Password login form -->
         <div *ngIf="passflag" class="col-{{num}}">
                <h6>LOGIN WITH PASSWORD</h6>
                <br />
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-{{passnum}}" style="font-size: smaller" *ngIf="phoneFlag">
                    <input type="checkbox" name="test" id="mobile" [checked]="isChecked === check_box_type.APPLY_FOR_JOB"
                      (click)="selectCheckBox(check_box_type.APPLY_FOR_JOB)" *ngIf="phoneFlag && emailFlag" />
                    <label style="margin-left: 10px;"> MOBILE </label>
                  </div>
                  <div class="col-{{passnum}}" style="font-size: smaller" *ngIf="emailFlag">
                    <input type="checkbox" name="test" style="margin-top: 3px;"
                      [checked]="isChecked === check_box_type.MODIFY_A_JOB"
                      (click)="selectCheckBox(check_box_type.MODIFY_A_JOB)" *ngIf="phoneFlag && emailFlag" />
                    <label style="margin-left: 10px;">EMAIL </label>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <div class="form-group">
                      <input *ngIf="isChecked == 0" class="form-control input-field" type="number"
                        placeholder="Enter Mobile Number" [(ngModel)]="userdetails['phone_no']">
                      <input *ngIf="isChecked != 0" class="form-control input-field" type="email" placeholder="Enter Email"
                        [(ngModel)]="userdetails['email']" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <input class="form-control input-field" type="password" autocomplete="off" placeholder="Enter Password "
                      [(ngModel)]="userdetails['password']" />
      
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-12 text-center">
                    <button class="btn btn-info btn-block loginbtn" type="submit" (click)="submit()"><i
                        class="fa fa-sign-in"></i> LOGIN</button>
      
                  </div>
                </div>
                
              </div>
      
      
          </div>
        </div>
      
      
      </div>
      
      <br>
      <div class="row" *ngIf="goaFlag" style="margin:1% ;">
        <div class="col-12 text-center">
          <h6>
            LOG IN USING YOUR GOOGLE ACCOUNT
          </h6>
          <h5>
            <div id="signin_button"></div>
          </h5>
        </div>
      </div>

      <p style="text-align:center ;" class="textsign">Don't have an account yet? <a class="signup-link"
          (click)="gotosignUp()">Sign up</a></p>
    </div>
    <div class="child2">
   
    </div>
  </div>
</div>
<br>
